import MinMaxSelect from "../../../../search-filter-options/MinMaxSelects/MinMaxSelects";

interface SquareFeetOptionProps {
  min?: number;
  max?: number;
  onChange: (min?: number, max?: number) => void;
  className?: string;
}

export default function SquareFeetOption({ min, max, onChange, className }: SquareFeetOptionProps) {
  return (
    <MinMaxSelect
      groupLabel="Square Feet"
      minValue={min}
      maxValue={max}
      onChange={onChange}
      className={className}
      options={[
        { label: "500", value: 500 },
        { label: "750", value: 750 },
        { label: "1,000", value: 1000 },
        { label: "1,250", value: 1250 },
        { label: "1,500", value: 1500 },
        { label: "2,000", value: 2000 },
        { label: "2,500", value: 2500 },
        { label: "3,000", value: 3000 },
        { label: "4,000", value: 4000 },
        { label: "5,000", value: 5000 },
        { label: "6,000", value: 6000 },
        { label: "7,500", value: 7500 },
      ]}
    />
  );
}
